import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const [timer, setTimer] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    if (timer === 0) {
      navigate("/");
      return;
    }

    const timeout = setTimeout(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [timer, navigate]);

  const handleRedirect = () => {
    navigate("/");
  };

  return (
    <Container>
      <h1>Sayfa Bulunamadı</h1>
      <h1>404 Not Found</h1>
      <h2>{timer} saniye sonra anasayfaya yönlendirileceksiniz.</h2>
      <HomeButton onClick={handleRedirect}>Ana Sayfaya Dön</HomeButton>
    </Container>
  );
}

const Container = styled.div`
  height: calc(100vh - 200px);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1,
  h2 {
    color: var(--main-color);
  }

  h2 {
    margin-top: 20px;
  }
`;

const HomeButton = styled.button`
  margin-top: 40px;
  padding: 10px 20px;
  font-size: 1rem;
  border: 1px solid var(--main-color);
  background-color: var(--main-color);
  color: white;
  border-radius: 5px;
  cursor: pointer;
  font-family: "MyCustomFont", sans-serif;

  &:hover {
    background-color: white;
    color: var(--main-color);
  }
`;

export default NotFound;
